import { ContactForm } from '../forms/ContactForm';

export function CTA() {
  return (
    <section id="contact" className="section-padding bg-gray-900 text-white">
      <div className="container-wrapper">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Transform Your Data Analysis?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join the waitlist for early access to QueryZen. Be among the first
              to experience natural language data queries with enterprise-grade
              security.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-primary-400 mr-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-gray-300">Free during beta period</span>
              </div>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-primary-400 mr-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-gray-300">
                  Priority onboarding support
                </span>
              </div>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-primary-400 mr-3"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-gray-300">
                  Direct feedback channel to our team
                </span>
              </div>
            </div>

            <div className="bg-primary-900/50 border border-primary-700 rounded-lg p-6">
              <h3 className="font-semibold text-primary-200 mb-2">
                Early Access Benefits
              </h3>
              <p className="text-primary-300 text-sm">
                Beta users will get lifetime discounts, advanced features first,
                and the opportunity to shape QueryZen&apos;s development
                roadmap.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-xl p-8">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Request Early Access
              </h3>
              <p className="text-gray-600">
                Fill out the form below and we&apos;ll get back to you within 24
                hours.
              </p>
            </div>

            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}
